import { useMemo } from 'react';
import { LIST_FIELD_FACETS } from 'api/ListsApi';
import { DataTypeType } from 'modules/domains';
import { useRestPostQuery } from 'utils/hooks/api/useRestPostQuery';
import { TypeAhead } from '../../../../domain/typeAhead';

export const useFetchTypeAheads = (field: string, dataType?: DataTypeType) => {
  const params = useMemo(() => ({ dataType, field }), [dataType, field]);
  const { data, isLoading, isError } = useRestPostQuery<TypeAhead[]>(LIST_FIELD_FACETS, params);

  return {
    data,
    isLoading,
    isError,
  };
};
